import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "grid" }
const _hoisted_2 = { class: "list" }
const _hoisted_3 = {
  key: 0,
  class: "summary"
}

import TrademarkSelector from "@/components/selectors/trademark.vue"
  import Breadcrumb from "@/components/breadcrumb.vue"
  import VerticalNavigator from "@/layouts/vertical_navigator.vue"
  import {ref} from "vue"
  import Button from "@/components/button.vue"
  import TrademarkSummary from "@/components/summaries/trademark.vue"
  import router from "@/router"
  import {Trademark} from "@/endpoints/rutsolve/gql/generated/graphql"
  
  
export default /*@__PURE__*/_defineComponent({
  __name: 'trademarks',
  setup(__props) {

  const selectedTrademark = ref<Trademark>(null)
  
  function trademarkRedirect() {
    router.push({
      name: "edit_trademark",
      params: {
        trademarkID: selectedTrademark.value.id
      }
    })
  }

return (_ctx: any,_cache: any) => {
  const _component_scoped = _resolveComponent("scoped")!

  return (_openBlock(), _createBlock(_component_scoped, null, {
    default: _withCtx(() => [
      _createVNode(VerticalNavigator, { links: [{
        title: 'Create',
        routeName: 'create_trademark'
      }] }, {
        default: _withCtx(() => [
          _createVNode(Breadcrumb, {
            links: [{
          title: 'RutSolve',
          routeName: 'index'
        }],
            title: "Trademarks"
          }),
          _cache[2] || (_cache[2] = _createElementVNode("h1", null, " Trademarks ", -1)),
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(TrademarkSelector, {
                value: selectedTrademark.value,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((selectedTrademark).value = $event))
              }, null, 8, ["value"])
            ]),
            (selectedTrademark.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  (_openBlock(), _createBlock(TrademarkSummary, {
                    key: selectedTrademark.value.id,
                    trademarkID: selectedTrademark.value.id
                  }, null, 8, ["trademarkID"])),
                  _createVNode(Button, {
                    title: "Edit",
                    image: require('@/images/edit_icon.png'),
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (trademarkRedirect()))
                  }, null, 8, ["image"])
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})